/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VerticalGuideLines/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VerticalGuideLines({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Content/OverlayGrid/VerticalGuideLines",
  videoHidden
  
}) {
  return (<React.Fragment
>
<div
  data-testid="VerticalGuideLines.Vertical"
  data-view-path={viewPath}
 hidden={!videoHidden}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="VerticalGuideLines.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="VerticalGuideLines.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
/>
<div
  data-testid="VerticalGuideLines.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
/>
<div
  data-testid="VerticalGuideLines.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
/>
<div
  data-testid="VerticalGuideLines.Vertical:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical5}`}
/>
<div
  data-testid="VerticalGuideLines.Vertical:6"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical6}`}
/>
<div
  data-testid="VerticalGuideLines.Vertical:7"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical7}`}
/>
</div>
</div>
{children}
</React.Fragment>)
}